<template>
  <div id="app">
    <TemplateEditor />
  </div>
</template>

<script>
import TemplateEditor from './views/TemplateEditor.vue'

export default {
  name: 'App',
  components: {
    TemplateEditor
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  height: 100vh;
  overflow: hidden;
}

body {
  font-family: '微软雅黑', Arial, sans-serif;
}
</style>
